import { useState } from "react";
import { X } from "lucide-react";

const tiles = [
  { id: 1, image: "/gallery/1.jpg" },
  { id: 2, image: "/gallery/2.jpeg" },
  { id: 3, image: "/gallery/3.jpeg" },
  { id: 4, image: "/gallery/4.png" },
  { id: 5, image: "/gallery/5.jpeg" },
  { id: 6, image: "/gallery/6.jpeg" },
  { id: 7, image: "/gallery/7.jpeg" },
  { id: 8, image: "/gallery/8.jpeg" },
  { id: 9, image: "/gallery/9.jpeg" },
  { id: 10, image: "/gallery/10.jpeg" },
  { id: 11, image: "/gallery/11.jpeg" },
  { id: 12, image: "/gallery/12.jpeg" },
];

export default function Gallery() {
  const [open, setOpen] = useState(null);

  return (
    <section id="gallery" data-testid="gallery-section" className="section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center fade-up max-w-2xl mx-auto">
          <div className="eyebrow justify-center mb-4">Event Gallery</div>
          <h2 className="section-title">
            Moments from our{" "}
            <span className="gold-text-gradient italic">previous events</span>
          </h2>

        </div>

        {/* Masonry */}
        <div className="mt-10 columns-1 sm:columns-2 lg:columns-3 gap-4 [column-fill:_balance]">
          {tiles.map((t) => (
            <button
              key={t.id}
              data-testid={`gallery-item-${t.id}`}
              onClick={() => setOpen(t)}
              className="gallery-item mb-4 w-full break-inside-avoid block group overflow-hidden rounded-2xl bg-black/20"
            >
              <img
                src={t.image}
                alt={`Gallery image ${t.id}`}
                className="w-full h-full object-cover transition duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500 flex items-end justify-end p-4">
                <span className="text-xs text-neutral-200">View</span>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {open && (
        <div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-[80] bg-black/85 backdrop-blur-md flex items-center justify-center p-6"
          onClick={() => setOpen(null)}
        >
          <button
            aria-label="Close"
            data-testid="gallery-lightbox-close"
            className="absolute top-6 right-6 text-white/80 hover:text-white"
            onClick={() => setOpen(null)}
          >
            <X size={26} />
          </button>
          <div
            className="max-w-4xl w-full overflow-hidden rounded-2xl bg-black/70"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={open.image}
              alt={`Gallery image ${open.id}`}
              className="w-full h-auto max-h-[80vh] object-contain"
            />
          </div>
        </div>
      )}
    </section>
  );
}
